import { ConsoleFacade } from '@/shared/helpers';
import Vue from 'vue';
import * as TypedMetricsModalComponent from '@/public/metrics/metrics-modal-component/metrics-modal-component';
import MetricsModalComponent from '@/public/metrics/metrics-modal-component/metrics-modal-component.vue';

export class MetricsModalOpener  {

    public static async openAsync(containerElement: Element, organizationalUnitPaths: string[], translations: { [key: string]: string; }, language: string): Promise<void> {

        const ComponentClass = Vue.extend(MetricsModalComponent);

        const instance = new ComponentClass({
            propsData: {
                organizationalUnitPaths,
                translations,
                language
            }
        });

        instance.$mount();

        ConsoleFacade.log(`Instancing and opening metrics modal component.`, instance, containerElement);

        containerElement.innerHTML = '';

        containerElement.appendChild(instance.$el);

        const typedInstance = instance as TypedMetricsModalComponent.default;

        await typedInstance.openModal();
    }
}
